import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import Button from "react-bootstrap-button-loader";
import Pagination from "react-js-pagination";
import {
  openUserCategoryModal,
  manageUserGroupModal,
  fetchUserListForManageUserGroup,
  searchUserListForManageUserGroup,
  clearUserListForManageUserGroup,
} from "DashboardUserAction";
import { itemCount } from "Constants";
import NoContent, { NO_USER } from "NoContent";
import AppuserList from "./appuser-list";
import LocaleStrings from "Languages";
import _ from "lodash";

var Loader = require("react-loaders").Loader;

class ManageAppuserGroup extends Component {
  constructor(props) {
    super(props);

    this.state = { pageNumber: 1, search: "" };
  }

  openGroupsModal = () => {
    this.props.openUserCategoryModal(true);
  };

  close = () => {
    this.props.manageUserGroupModal({ showModal: false });
    this.props.clearUserListForManageUserGroup({});
    this.props.finishOperationsCallback();
  };

  onSearchUser = (event) => {
    var search = event.target.value;
    let pageNumber = 1;

    this.setState({ search, pageNumber }, () =>
      this.paginationCallback(pageNumber)
    );
  };

  paginationCallback = (pageNumber) => {
    let { search } = this.state;

    if (search == "") {
      this.props.fetchUserListForManageUserGroup(
        this.props.session,
        pageNumber
      );
    } else {
      this.props.searchUserListForManageUserGroup(
        this.props.session,
        search,
        pageNumber
      );
    }
    this.setState({ pageNumber });
  };

  renderUserList() {
    let { appUserListGroupManage } = this.props;
    let pageDataLength = appUserListGroupManage.data.length;
    let { pageNumber } = this.state;
    return _.map(appUserListGroupManage.data, (appUser) => {
      return (
        <AppuserList
          key={appUser.appuserid}
          appUser={appUser}
          pagination={this.paginationCallback}
          pageDataLength={pageDataLength}
          currentPage={pageNumber}
        />
      );
    });
  }

  render() {
    var { deviceSize, appuserGroupManageModal, appUserListGroupManage } =
      this.props;
    var { pageNumber, search } = this.state;

    return (
      <Modal
        className="modal-container"
        show={
          appuserGroupManageModal && appuserGroupManageModal.showModal === true
            ? true
            : false
        }
        onHide={this.close}
        animation={true}
        keyboard={false}
        backdrop="static"
        dialogClassName="modal-lg"
      >
        <Modal.Header>
          <div className="import-modal-title">
            {LocaleStrings.user_manage_user_category_text_manage_users}
          </div>
          <button
            type="button"
            className="i-custom-cross-popup pull-right"
            onClick={() => this.close()}
          >
            <img
              className="i-custom-small"
              src="../../style/images/custom-icons/cross-black.png"
            />
          </button>
        </Modal.Header>
        <Modal.Body>
          {appUserListGroupManage && appUserListGroupManage.data ? (
            <div>
              <div style={{ marginTop: -25, marginBottom: 20 }}>
                <div className="vertical-align-center-justify-right gap-1">
                  <div style={{ width: 250 }}>
                    <input
                      className="form-control mapsearch"
                      placeholder={`${LocaleStrings.button_search} by name & email`}
                      type="search"
                      value={search}
                      onChange={this.onSearchUser}
                    />
                  </div>

                  <Button
                    className="btn-custom-blue"
                    onClick={this.openGroupsModal}
                  >
                    {LocaleStrings.button_manage_category}
                  </Button>
                </div>
              </div>
              <div className="appuser-form scrollable-modal">
                {appUserListGroupManage.data &&
                appUserListGroupManage.data.length > 0 ? (
                  <div
                    className="scrollable-content-"
                    // style={{ height: deviceSize.height - 200 }}
                  >
                    <table className="table">
                      <thead>
                        <tr>
                          <th style={{ width: "30%" }}>
                            {LocaleStrings.user_table_list_name}
                          </th>
                          <th style={{ width: "70%" }}>
                            {LocaleStrings.user_table_list_groups}
                          </th>
                        </tr>
                      </thead>
                      <tbody className="">{this.renderUserList()}</tbody>
                    </table>
                  </div>
                ) : (
                  <NoContent contentType={NO_USER} />
                )}

                {appUserListGroupManage.count > itemCount ? (
                  <div className="mt-20 vertical-align-center-justify-right">
                    <Pagination
                      activePage={pageNumber}
                      itemsCountPerPage={itemCount}
                      totalItemsCount={appUserListGroupManage.count}
                      pageRangeDisplayed={10}
                      onChange={this.paginationCallback}
                    />
                  </div>
                ) : null}
              </div>
            </div>
          ) : (
            <div className="loader-container">
              <Loader
                type="line-scale-pulse-out-rapid"
                active
                className="loader-div"
              />
              <div className="loader-info">{LocaleStrings.preparingUsers}</div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button className="btn btn-custom-white" onClick={this.close}>
            {LocaleStrings.button_close}
          </Button>
        </Modal.Footer>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    deviceSize: state.deviceSize,
    session: state.session,
    appuserGroupManageModal: state.appuserGroupManageModal,
    appUserListGroupManage: state.appUserListGroupManage,
  };
}

export default connect(mapStateToProps, {
  openUserCategoryModal,
  manageUserGroupModal,
  fetchUserListForManageUserGroup,
  searchUserListForManageUserGroup,
  clearUserListForManageUserGroup,
})(ManageAppuserGroup);
